import {
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
  httpUploadFormData,
} from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  createSchedule(
    dateTime,
    cycleType,
    morning = [],
    afternoon = [],
    evening = []
  ) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/schedule?dateTime=${dateTime}&cycleType=${cycleType}`;

    return httpPost(apiUrl, { morning, afternoon, evening });
  }

  getSchedule(rangeStart, rangeEnd) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/schedule/range?rangeStart=${rangeStart}&rangeEnd=${rangeEnd}`;

    return httpGet(apiUrl);
  }

  getScheduleById(dateTime) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/schedule/dateTime/${dateTime}`;

    return httpGet(apiUrl);
  }

  deleteSchedule(cycleTag, rangeStart, rangeEnd) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/schedule?cycleTag=${cycleTag}&rangeStart=${rangeStart}&rangeEnd=${rangeEnd}`;

    return httpDelete(apiUrl);
  }

  modifySchedule(cycleTag, morning = [], afternoon = [], evening = []) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/schedule?cycleTag=${cycleTag}`;

    return httpPut(apiUrl, { morning, afternoon, evening });
  }
}
